import { JAEGER_PROCESS_TAG_FIELD } from './jaeger-process-tag-field';
/** Flattened Jaeger process tag field prefix in OpenSearch: `process.tag.<key>`. */
export const JAEGER_PROCESS_TAG_PREFIX = `${JAEGER_PROCESS_TAG_FIELD}.`;
//# sourceMappingURL=jaeger-process-tag-prefix.js.map